import React from 'react';
import * as d3 from 'd3';
import ChartComponent from './ChartComponent';

const Legend = ({ data, colorFunction = d => {
    const color = d3.scaleOrdinal(d3.schemeCategory10);
    return color(d.name);
} }) => {
    function draw(chart) {
        const legend = chart.append("table").attr('class', 'legend');

        const row = legend.append("tbody").selectAll("tr").data(data).enter().append("tr");

        row.append("td")
            .style("padding-right", "5px")
            .append("svg")
            .attr("width", 16)
            .attr("height", 16)
            .append("circle")
            .attr("cx", 8)
            .attr("cy", 8)
            .attr("r", 6)
            .attr("fill", colorFunction);

        row.append("td")
            .style("text-align", "left")
            .style("white-space", "nowrap")
            .style("padding-right", "10px")
            .text(function (d) { return d.nameLabel; });

        row.append("td").attr("class", 'legendValue')
            .style("text-align", "right")
            .style("white-space", "nowrap")
            .text(function (d) { return d3.format(",")(d.value); });

    }

    function update(chart) {
        let l = chart.select("tbody").selectAll("tr").data(data);

        l.select(".legendValue").text(function (d) { return d3.format(",")(d.value); });
    }

    return (
        <ChartComponent
            draw={draw}
            update={update}
        />
    )
}

export default Legend
